import {Component, Input, OnInit} from '@angular/core';
import {StateManagerService} from '../../services/state-manager.service';
import {DetaillineDTOModel} from '../../models/detaillineDTO.model';
import {CollectionsNames} from '../../definitions/collections-names';
import {AlertController, ModalController} from '@ionic/angular';
import {StockTakeHelperService} from '../../services/stock-take-helper.service';
import {DocumentModel} from '../../models/document.model';

@Component({
    selector: 'app-stock-take-products-manual',
    templateUrl: './stock-take-products-manual.component.html',
    styleUrls: ['./stock-take-products-manual.component.scss'],
})
export class StockTakeProductsManualComponent implements OnInit {
    @Input() stockCount: DocumentModel;
    productList: DetaillineDTOModel[];
    queryText = '';

    constructor(private stateManager: StateManagerService,
                private collectionNames: CollectionsNames,
                private modalController: ModalController,
                private stockTakeHelper: StockTakeHelperService,
                private alertController: AlertController) {
    }

    ngOnInit() {
        this.productList = this.stateManager.getCollection(this.collectionNames.PRODUCTTYPE);
    }

    cancelModal() {
        this.modalController.dismiss();
    }

  async setProduct(product: DetaillineDTOModel) {
      const alert = await this.alertController.create({
          header: 'Equipment found',
          message: 'Please inform quantity.',
          backdropDismiss: false,
          inputs: [
              {
                  name: 'qty',
                  type: 'number',
                  placeholder: 'Quantity'
              }
          ],
          buttons: [
              {
                  text: 'Cancel',
                  role: 'cancel',
                  cssClass: 'secondary',
                  handler: () => {
                  }
              }, {
                  text: 'Yes',
                  handler: data => {
                      this.stockTakeHelper.addItemToStockCount(this.stockCount, product, data.qty);
                  }
              }
          ]
      });
      await alert.present();
  }
}
